<script setup lang="ts">
import type { TProps as TPropsTrailStickyElement } from './TrailDS/StickyElement.vue'

type TProps = {} & TPropsTrailStickyElement

const props = defineProps<TProps>()

const { data: globalCommonLinks } = useNuxtData('global-common-links')

const signUpLink = computed(() => {
  return globalCommonLinks?.value?.find((link: TLink) =>
    link.url.includes('/sign-up/onboarding')
  )
})

const contactUsLink = computed(() => {
  return globalCommonLinks?.value?.find((link: TLink) =>
    link.url.includes('/onboarding/contact-us')
  )
})

const { y } = useScroll(window, {
  behavior: 'smooth',
  throttle: 100,
  idle: 200,
})

const SCROLL_Y_THRESHOLD = 500

const shouldShow = computed(() => {
  const linksDataExists = !!signUpLink.value || !!contactUsLink.value
  const isScrollYThresholdCrossed = y.value > SCROLL_Y_THRESHOLD
  return linksDataExists && isScrollYThresholdCrossed
})
</script>

<template>
  <TransitionSlide
    :offset="[0, '100%']"
    mode="in-out"
    easing="ease-in-out"
    no-opacity
  >
    <LazyTrailDSStickyElement
      class="w-full lg:hidden p-4 md:p-8 inline-flex justify-center items-center gap-2 md:gap-4 bg-white shadow-full-lg-top"
      :position="props.position"
      :should-show
    >
      <a v-if="signUpLink" :href="signUpLink.url">
        <LazyTrailDSButton class="hidden md:inline-flex" variant="primary">
          {{ signUpLink.text }}
        </LazyTrailDSButton>
      </a>

      <a v-if="contactUsLink" :href="contactUsLink.url">
        <LazyTrailDSButton variant="secondary">
          {{ contactUsLink.text }}
        </LazyTrailDSButton>
      </a>
    </LazyTrailDSStickyElement>
  </TransitionSlide>
</template>

<style lang="scss" scoped>
a :deep(button > div) {
  @apply w-64 md:w-72;
}
</style>
